import { createActionGroup, props } from '@ngrx/store';
import { ShowError } from '../containers/show-error/models/show-error';
import { ConfigAppOutputDto } from '@shared/api/model/config-app-output-dto';
import { TimezoneAppItemOutputDto } from '@shared/api/model/timezone-app-item-output-dto';

export const CoreActions = createActionGroup({
    source: 'App',
    events: {
        'Init': props,
        'Throw Error': props<{ error: ShowError }>(),
        'Set Timezone': props<{ timezone?: TimezoneAppItemOutputDto }>(),
        'Set Timezone Success': props<{ timezone?: TimezoneAppItemOutputDto }>(),
    }
})

export const CoreApiActions = createActionGroup({
    source: 'App API',
    events: {
        'Load Menu Items': props,
        'Load Menu Items Success': props,

        'Load App Config': props,
        'Load App Config Success': props<{appConfig: ConfigAppOutputDto}>(),

        'Load Timezone': props<{ timezone?: string }>(),
        'Load Timezone Success': props<{timezonesList: TimezoneAppItemOutputDto[]}>(),
    }
})